angular
  .module 'bookAndPay'
  .directive 'stripeForm', () ->
    restrict: 'EA'
    template: require('templates/book_and_pay/stripe_form.html.slim')
    scope:
      cart: '='
      months: '='
      years: '='
      currency: '='
      expired: '='
      toNewCart: '&'
      setLoading: '&'
      onUnavailable: '&'
    controller: (
      $scope,
      $state,
      $http,
      $timeout,
      DataService,
      CreditCardValidationService,
    ) ->
      $scope.data = DataService
      $scope.creditCard = {}

      initStripe = ->
        $scope.stripe = Stripe($scope.cart.realtime_public_key)
        elements = $scope.stripe.elements()
        style =
          base:
            fontFamily: 'Helvetica'
            fontSize: '18px'
            fontWeight: 400
            '::placeholder': color: '#828282'
          invalid:
            color: '#fa755a'
            iconColor: '#fa755a'

        $scope.cardElement = elements.create('card', style: style, disabled: $scope.expired)

        $scope.$watch 'expired', (expired) ->
          if expired && $scope.cardElement?.update
            $scope.cardElement.update(disabled: expired)

        $timeout ->
          $scope.cardElement.mount('#card-element')

        onCardChange = ->
          $scope.cardElement.on 'change', (event) ->
            $timeout ->
              $scope.cardReady = event.complete
              displayErrorEl = document.getElementById('card-errors')
              if displayErrorEl?
                if event.error
                  displayErrorEl.textContent = event.error.message
                else
                  displayErrorEl.textContent = ''
        onCardChange()

      if window.Stripe
        initStripe()
      else
        $scope.stripeUnavailable = true
        $scope.onUnavailable()

      $scope.cardReady = false

      submitPaymentMethod = (options) ->
        $scope.stripe.confirmCardPayment($scope.cart.realtime_token, {
          payment_method:
            card: $scope.cardElement
            billing_details: options.billing_details
        })

      getPaymentMethodReference = ->
        options =
          billing_details:
            name: $scope.creditCard.name
        submitPaymentMethod(options).then (confirmResult) ->
          $timeout ->
            if confirmResult.error
              if window.Rollbar
                window.Rollbar.error('Book and pay card authentication error', message: confirmResult.error.message, code: confirmResult.error.code)
              $scope.errorMessage = 'We are unable to authenticate your payment method. Please try again.'
              $scope.isLoading = false
              $scope.setLoading(loading: false)
            else
              intent = confirmResult.paymentIntent
              $scope.stripe.createPaymentMethod('card', $scope.cardElement, options).then (createPaymentMethodResponse) ->
                $timeout ->
                  if createPaymentMethodResponse?.error
                    if window.Rollbar
                      window.Rollbar.error('Book and pay createPaymentMethod error', createPaymentMethodResponse.error)
                    $scope.errorMessage = 'We were unable to read your card details. Please try again.'
                    $scope.isLoading = false
                    $scope.setLoading(loading: false)
                  else
                    stripeResponseHandler(intent.payment_method, createPaymentMethodResponse.paymentMethod)

      $scope.formReady = ->
        $scope.creditCard.name?.length && $scope.cardReady &&
          !$scope.isLoading && $scope.creditCard.termsAccepted

      $scope.onSubmit = ->
        return unless $scope.formReady()
        $scope.setLoading(loading: true)
        $scope.isLoading = true
        $scope.errorMessage = ''
        getPaymentMethodReference()

      $scope.reload = ->
        window.location.reload()

      stripeResponseHandler = (token, paymentMethodReference) ->
        params =
          cart:
            payment_method_reference: token
            cardholder_name: paymentMethodReference.billing_details.name
            card_brand: paymentMethodReference.card.brand
            card_number: paymentMethodReference.card.last4
            card_expiry_month: paymentMethodReference.card.exp_month
            card_expiry_year: paymentMethodReference.card.exp_year
            payment_success: true

        url = "/websites/#{window.DATA.domain}/book_and_pay/carts/#{$scope.cart.cart_uuid}/handle_payment_result"
        $http.put(url, params).then (response) ->
          $scope.setLoading(loading: false)
          $state.go 'bookAndPay.complete', uuid: $scope.cart.cart_uuid
        , (response) ->
          if window.Rollbar
            window.Rollbar.error('Book and pay handle_payment_result error', response.data)
          $scope.isLoading = false
          $scope.setLoading(loading: false)
          $scope.errorMessage = 'An unexpected error occurred. Please try again later.'
